import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        modal: {
            position: 'fixed',
            zIndex: 1201,
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            overflow: 'auto',
            background: 'background.overlay-modal',
            display: 'flex',
            alignContent: 'center',
        },
        content: {
            marginX: 'auto',
            marginY: {base: remCalc(16), lg: 'auto'},
            borderRadius: remCalc(12),
            width: {base: 'auto', lg: remCalc(688)},
            padding: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            position: 'relative',
            flexDirection: 'column',
            bg: 'background.base.default',
        },
        close: {
            position: 'absolute',
            top: remCalc(24),
            right: remCalc(24),
            boxSize: remCalc(16),
            //padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
            color: 'foreground.neutral.default',
            bg: 'transparent',
            _hover: {
                bg: 'transparent',
            },
            _active: {
                bg: 'transparent',
            },
        },
        text: {
            textStyle: 'body-large',
            color: 'foreground.neutral.default',
            borderBottom: 'small',
            borderColor: 'foreground.neutral.default',
            borderStyle: 'solid',
            paddingBottom: remCalc(16),
            marginBottom: {base: remCalc(16), md: remCalc(24)},
        },
    },
    variants: {
        wishlist: {
            content: {
                padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
                paddingBottom: remCalc(16),
            },
            text: {
                marginBottom: {base: remCalc(24), lg: remCalc(40)},
            },
        },
        notifyMe: {
            header: {
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                w: 'full',
                mb: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            },
            close: {
                position: 'relative',
                top: 'auto',
                right: 'auto',
                boxSize: remCalc(16),
                color: 'foreground.neutral.default',
                bg: 'transparent',
                _hover: {
                    bg: 'transparent',
                },
                _active: {
                    bg: 'transparent',
                },
            },
            contentWrapper: {
                flexDirection: 'column',
                gap: 'xxsmall',
            },
            title: {
                textStyle: 'body-medium',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            icon: {
                boxSize: remCalc(16),
                color: 'foreground.neutral.default',
            },
            iconWrapper: {
                height: remCalc(36),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            text: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'foreground.neutral.muted',
                paddingBottom: ['small.base', 'small.sm', 'small.md', 'small.lg'],
                marginBottom: 0,
                borderBottom: 'none',
            },
            childrenWrapper: {},
        },
        native: {},
    },
}
